interface News{
  date:string,
  html:string,
  url:string,
}

window.expo2025newslist=[
  {
    date:"2025.2.28",
    html:`オカムラ社員による劇団「ザ・オカムラ座」が大阪・関西万博において演劇『12人のとびだす会社員』を上演、公演での12人の主役を決定`,
    url:"https://www.okamura.co.jp/corporate/news/exhibition/2025/EXPO_2025_2.html",
  },
  {
    date:"2024.12.10",
    html:`オカムラが「2025年日本国際博覧会（大阪・関西万博）」に出展`,
    url:"https://www.okamura.co.jp/corporate/news/exhibition/2024/EXPO_2025_1.html",
  },
];
